import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { USER_EXCHNAGE_URL } from '../../../Url/Url';
import axios from 'axios';

const UserPaymentHistory = () => {
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchPaymentHistory = async () => {
      try {
        const response = await axios.get(`${USER_EXCHNAGE_URL}/UserPaymentHistory`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        const data = response.data.data;
        setPaymentHistory(data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load payment history');
        setLoading(false);
      }
    };

    fetchPaymentHistory();
  }, []);

  const currencySymbols = {
    USD: "$",
    INR: "₹",
    AED: "د.إ", 
  };

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  return (
    <TableWrapper>
      <h2> Payment History</h2>

      {loading ? (
  <LoaderWrapper>
    <Spinner />
  </LoaderWrapper>
) : error || paymentHistory.length === 0 ? (
  <NoDataText>You don’t have any payment history yet.

  </NoDataText>
) : (
        <StyledTable>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Event Name</th>
                <th>Status</th>
                <th>Payment Time</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {paymentHistory.map((payment, index) => (
                <tr key={index}>
                  <td>{payment.order_id}</td>
                  <td>{payment.event_name}</td>
                  <td><StatusBadge status={payment.status}>{payment.status}</StatusBadge></td>
                  <td>{formatDateTime(payment.created_at)}</td>
                  <td>
                    {currencySymbols[payment.currency] || "₹"} {parseFloat(payment.amount).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
        </StyledTable>
      )}
    </TableWrapper>
  );
};

export default UserPaymentHistory;

// Styled Components
const TableWrapper = styled.div`
  margin: 30px auto;
  padding: 30px;
  max-width: 1400px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);

  h2 {
    text-align: center;
    margin-bottom: 2rem;
    font-size: 1.75rem;
    color: #333;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;

  th,
  td {
    padding: 14px 18px;
    text-align: center;
  }

  th {
    background-color: #f0f4f8;
    font-weight: 700;
    color: #333;
    font-size: 0.95rem;
    border-bottom: 2px solid #dce3ea;
  }

  td {
    border-bottom: 1px solid #eef1f4;
    color: #444;
  }

  tbody tr:hover {
    background-color: #f8fbfc;
  }
`;

const StatusBadge = styled.span`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: capitalize;
  background-color: ${({ status }) =>
    status === 'Success'
      ? '#d1f7d6'
      : status === 'Failed'
      ? '#fddede'
      : '#fff3cd'};
  color: ${({ status }) =>
    status === 'Success'
      ? '#22863a'
      : status === 'Failed'
      ? '#d32f2f'
      : '#856404'};
`;

const ErrorText = styled.p`
  color: red;
  text-align: center;
  font-weight: 500;
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #dfe6ec;
  border-top-color: #0077ff;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;


const NoDataText = styled.p`
  text-align: center;
  font-size: 1rem;
  color: #777;
  margin-top: 40px;
`;
